import React, { forwardRef } from 'react';
import './button.css';

/**
 * Button: the only button style in the product.
 * variant: primary | secondary | ghost | danger | link | brand
 *          (legacy aliases: surface, outline, default -> secondary; warning -> secondary)
 * size: xs | sm | md | lg
 * Icon-only buttons must pass aria-label (or title).
 */
const VARIANT_ALIASES = {
    surface: 'secondary',
    outline: 'secondary',
    default: 'secondary',
    warning: 'secondary',
    error: 'danger',
};

const Spinner = () => (
    <svg className="ds-btn__spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
);

const Button = forwardRef(function Button(
    {
        variant = 'secondary',
        size = 'md',
        leadingIcon,
        trailingIcon,
        className = '',
        children,
        isLoading = false,
        fullWidth = false,
        iconOnly = false,
        type = 'button',
        ...rest
    },
    ref
) {
    const v = VARIANT_ALIASES[variant] || variant;
    const hasLabel = children !== undefined && children !== null && children !== false && children !== '';
    const classes = [
        'yelo-btn',
        `yelo-btn--${v}`,
        `yelo-btn--${size || 'md'}`,
        fullWidth ? 'yelo-btn--full' : '',
        iconOnly || !hasLabel ? 'yelo-btn--icon' : '',
        isLoading ? 'is-loading' : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <button
            ref={ref}
            type={type}
            className={classes}
            disabled={isLoading || rest.disabled}
            aria-busy={isLoading || undefined}
            {...rest}
        >
            {isLoading ? (
                <span className="yelo-btn__icon"><Spinner /></span>
            ) : (
                leadingIcon && <span className="yelo-btn__icon">{leadingIcon}</span>
            )}
            {hasLabel && <span className="yelo-btn__label">{children}</span>}
            {trailingIcon && !isLoading && <span className="yelo-btn__icon">{trailingIcon}</span>}
        </button>
    );
});

export default Button;
